import React from "react";
import styled from "styled-components";
import { LuQuote } from "react-icons/lu";
import { Container, Reveal, Section, SectionHeader } from "./ui";

const testimonials = [
  {
    id: 1,
    text: "Working with this development team was a game-changer for our startup. The IoT integration they built for our smart office solution exceeded all expectations. The system is robust, scalable and beautifully designed.",
    name: "Sarah Chen",
    role: "CTO",
    company: "TechFlow Solutions",
    avatar: "SC",
  },
  {
    id: 2,
    text: "The mobile app this team developed for our e-commerce platform is phenomenal. Performance is outstanding and the user experience is incredibly smooth. Customer engagement increased by 300% after launch.",
    name: "Michael Rodriguez",
    role: "Product Manager",
    company: "Digital Commerce Inc",
    avatar: "MR",
  },
  {
    id: 3,
    text: "Their DevOps expertise completely transformed our deployment process. What used to take hours now takes minutes, and our system reliability has improved dramatically.",
    name: "Emily Watson",
    role: "Engineering Lead",
    company: "CloudTech Systems",
    avatar: "EW",
  },
  {
    id: 4,
    text: "The full-stack web application they built for our healthcare platform is exceptional. Their attention to detail, security implementation and interface design are all top-notch.",
    name: "Dr. James Thompson",
    role: "Founder",
    company: "HealthTech Innovations",
    avatar: "JT",
  },
];

const Grid = styled.ul`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 24px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 16px;
  }
`;

const Card = styled(Reveal)`
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 36px;
  background: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-lg);

  > svg {
    width: 28px;
    height: 28px;
    color: var(--color-primary);
    margin-bottom: 20px;
  }

  blockquote {
    flex: 1;
    font-size: 1.0625rem;
    line-height: 1.7;
    color: var(--color-ink);
    margin-bottom: 28px;
  }

  @media (max-width: 640px) {
    padding: 24px;
  }
`;

const Author = styled.figcaption`
  display: flex;
  align-items: center;
  gap: 14px;
  padding-top: 24px;
  border-top: 1px solid var(--color-border);
`;

const Avatar = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: var(--color-primary-soft);
  color: var(--color-primary);
  font-family: var(--font-heading);
  font-size: 0.9375rem;
  font-weight: 600;
`;

const AuthorText = styled.div`
  line-height: 1.4;

  strong {
    display: block;
    font-weight: 600;
    color: var(--color-ink);
  }

  span {
    font-size: 0.875rem;
    color: var(--color-muted);
  }
`;

const Testimonials = () => (
  <Section id="testimonials">
    <Container>
      <SectionHeader
        eyebrow="Testimonials"
        title="What our clients say"
        lead="Feedback from teams we've partnered with across IoT, e-commerce, DevOps and healthcare."
      />

      <Grid>
        {testimonials.map((item, index) => (
          <li key={item.id}>
            <Card forwardedAs="figure" delay={(index % 2) * 0.05}>
              <LuQuote aria-hidden="true" />
              <blockquote>{item.text}</blockquote>
              <Author>
                <Avatar aria-hidden="true">{item.avatar}</Avatar>
                <AuthorText>
                  <strong>{item.name}</strong>
                  <span>
                    {item.role}, {item.company}
                  </span>
                </AuthorText>
              </Author>
            </Card>
          </li>
        ))}
      </Grid>
    </Container>
  </Section>
);

export default Testimonials;
